import * as React from "react";

import { EMDASH } from "@eave/shared/utils/general";

interface IProps {
  value: any;
  formatting?: Function;
}

const ReadOnlyValue: React.SFC<IProps> = ({ value, formatting }) => {
  if (value === null || value === undefined || value === "") {
    return <span data-value="empty">{EMDASH}</span>;
  }
  if (typeof formatting === "function") {
    return <span data-value={value}>{formatting(value)}</span>;
  }
  return <span data-value={value}>{value}</span>;
};

export default ReadOnlyValue;
